<template>
    <div class="acomodar">
        <SeguimientoRenovacionesVue />
  
    </div>
</template>

<script>
import SeguimientoRenovacionesVue from '@/components/ModContratos/SegRenovacion/SegRenovacion.vue'
export default {
    name: 'SolimanologSeguimientoDeRenovaciones',
    components:{
        SeguimientoRenovacionesVue
    },

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style  scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  margin-right: 0.5rem !important;
  margin-top: 9px;
  margin-bottom: 9px;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y:hidden;
}
</style>